import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from "reactstrap";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import get from "lodash/get";
import { baseUrl, GenaiUrl,QuizyUrl, TempUrl } from "../../libs/env";
import { Level } from "./../../components/badges/level";
import { SuggestedTime } from "./../../components/badges/suggested_time";
import OpenButton from "./../../components/buttons/OpenButton";
import { ReportBugButton } from "../../components/buttons/ReportBugButton";
import { Header } from "./../../components/header/header";
import { ExerciseType } from "./../../components/heading/heading";
import SimpleModal from "./../../components/modals/SimpleModal";
import QuestionDescription from "./../../components/question/QuestionDescrption";
import { QuestionHeading } from "./../../components/question/question_heading";
import {DownloadPDFHelper}  from "../exercise/pdf_helper/PdfHelper";
import { Timer } from "./../../components/timer/timer";
import { getStudentid } from "../../libs/api/quiz";
import { TextArea } from "./../../components/writting_essay/textarea";
import { BottomButtonPannel } from "./BottomButtonPannel";
import WaitModel from "../../components/modals/WaitModel";
import { getQuizId } from "../../App";
import quizAPI from "../../libs/api/quiz";
import { AccountType, exerciseType } from "../../components/constants/constants";
import { size } from "lodash";
import { handleHeaderInput } from "../../components/edit_quiz_helper/EditQuizHelper";
import { useLocation } from "react-router-dom";
import { TempHeader } from "./TempHeader";
import SampleReportModal from "../../components/modals/SampleReportModal";

let answers;
let params = new URL(document.location).searchParams;
let book_id = params.get("book_id");
let exercise_id = params.get("exercise_id");
let exercise_page_number = params.get("e-p-n");
let show_exercises = params.get("s-e");
let search = params.get("search");
let st_c_t_c = params.get("st_c_t_c");
let st_le_c = params.get("st_le_c");
let ex_b_c = params.get("ex_b_c");
let st_th_c = params.get("st_th_c");
let st_fn_c = params.get("st_fn_c");
let st_gr_c = params.get("st_gr_c");
let came_from_student = params.get("student");
let return_to_assignment_list = null;
let redirect = params.get("redirect");
let quizy_template = params.get("quizy_template");
if (came_from_student) {
  return_to_assignment_list = true;
}

let first_call = true;

const WrittingQuiz = ({
  isLoaded,
  data,
  onSubmit,
  isReview,
  isSaveAndExit,
  isSubmitting,
  onUpdate,
}) => {
  const { pathname } = useLocation()
  let edit_template = "false";
  let container = "container";
  let padding = "g-0 px-2";
  let quizbackground = "bg-quiz-content";
  let Reportbug="bg-white";
  let Quizyheight = "pb-4";
  let Questionscroll = "pt-2";
  let wraperbackground = "bg-white";
  let margin0 = "border bg-white border-top-0 px-4 page-break rounded-footer py-3 footer-sticky";
  let p_size = "p-2";
  let temp_rounded = "border-bottom-0";
  // if (edit_template === "true") {
  //   container = "";
  //   padding = "px-0";
  //   quizbackground = "px-0";
  //   Reportbug = "bg-white d-none";
  //   Questionscroll = "template_scroll preview_fsize";
  //   margin0 = "py-2 mx-0"
  //   Quizyheight="pb-4 p-2";
  //   p_size = "p-1";
  // }
  if (pathname.includes(GenaiUrl)) {
    container = "bg-lblue";
    Questionscroll = "";
    Quizyheight = "pb-4 min-h-84 quiz-detail-width";
    padding = "px-5 g-0";
    temp_rounded = "border-bottom rounded-footer";
    quizbackground = "px-0";
    Reportbug = "bg-white d-none";
    margin0 = "page-break rounded-footer py-3";
  }
  else if (pathname.includes(TempUrl))
  {
    container = "";
    padding = "px-0";
    quizbackground = "px-0";
    Reportbug = "bg-white d-none";
    Questionscroll = "template_scroll preview_fsize";
    margin0 = "py-2 mx-0"
    Quizyheight="pb-4 p-2";
    edit_template = "true";
    p_size = "p-1";
  }
  else if ((redirect === "templates" || window.location.origin.includes(QuizyUrl)) && !quizy_template) {
    container = "";
    padding = "g-0";
    Reportbug="bg-quiz-content";
    Quizyheight="min-h-84 py-4";
    temp_rounded = "border-bottom rounded-footer";
    margin0 = "page-break rounded-footer py-4";
  }
  const [Contentedit, setContentedit] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);
  const focusBlink = (e) => {
    setIsBlinking(false);
  }
  const blurBlink = (e) => {
    if(Contentedit)
    {
      setIsBlinking(true);
    }
  }

  const contentRef = useRef();
  const downloadPDF = () => {
    DownloadPDFHelper({contentRef});
  };
  const notify = () =>
    toast.success("Successfully Saved!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: 1,
    });
  const [items, setItems] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [message, setMessage] = useState(
    "Please wait whilst we redirect you ..."
  );
  const [isSystemRedirection, setIsSystemRedirection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [waitModal, setWaitModel] = useState(false);
  const waitToggle = () => setWaitModel(!waitModal);
  const [isOpenAdditionalResourceModal, setOpenAdditionalResourceModal] =
    useState(false);
  const additionalResourceToggle = () =>
    setOpenAdditionalResourceModal(!isOpenAdditionalResourceModal);
  const [timer, setTimer] = useState();
  let [wordsCounter, setWordsCount] = useState(
    data.answers ? data.answers.replace(/[\n]/g, " ").trim().split(" ").length : 0
  );
  const [ReportModal, setReportModal] = useState(false);
  const ReportToggle = () => setReportModal(!ReportModal);

  if (data.completed_at) {
    isReview = true;
  }

  if (data && data.answers && data.completed_at === null && first_call) {
    first_call = false;
    answers = data.answers;
  }
  // answers=data.answers && data.completed_at === null ? data.answers : null;
  const [isStopTimer, setIsStopTimer] = useState(false);

  useEffect(() => {
    setTimer(
      data.status === "New" || data.time_spent === null
        ? parseInt(data?.assignment_allowed_time) * 60 
        : get(data, "time_spent")
    );
  }, [data]);

  useEffect(() => {
    if (data.is_browse_alert && data.user_type === AccountType.STUDENT && !isSystemRedirection) {
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    }
  });
  const alertUser = (e) => {
    if (data.is_browse_alert && data.user_type === AccountType.STUDENT) {
      e.preventDefault();
      e.returnValue = "";
    }
  };

  const creatQuizDataAndSubmit = () => {
    const timer = window.sessionStorage.getItem("timer");
    let  time_spent;
    if (window.location.origin.includes(QuizyUrl))
    {
      time_spent = parseInt((data.assignment_allowed_time) * 60) - parseInt(timer) ;
    }
    else
    {
      time_spent = parseInt(timer)
    }
    let quiz_data = {
      is_submit: true,
      time_spent: time_spent,
      answers,
    };
    setIsStopTimer(true);
    onSubmit(quiz_data);
    setIsSubmit(true);
    toggle();
    waitToggle();
    setIsSystemRedirection(true);
  };
  useEffect(() => {
    if (isSubmit && data.user_type === AccountType.STUDENT) {
      function getSubmissionStatus() {
        quizAPI
          .get_submission_status({ id: getQuizId() })
          .then((res) => res.json())
          .then((json) => {
            if (json.success && json.redirection_url) {
              window.location.replace(`${baseUrl}/${json.redirection_url}`);
            } else {
              setItems(json);
            }
          });
      }
      getSubmissionStatus();
      setInterval(() => getSubmissionStatus(), 10000);
    }
  }, [data, isSubmit]);

  if (isSubmit && data.user_type === AccountType.STUDENT) {
    setInterval(function () {
      if (items && !items.success) {
        setMessage(
          "Your submission is in a queue, you can access your report later from the homework tab."
        );
        setInterval(() => {
          window.location.replace(
            `${baseUrl}/student/assignments?task_completed=true`
          );
        }, 10000);
      }
    }, 30000);
  }
  const creatQuizDataAndSave = () => {
    if (!isReview) {
      const timer = window.sessionStorage.getItem("timer");
      let quiz_data = {
        is_submit: false,
        time_spent: parseInt(timer),
        answers,
      };
      setIsStopTimer(true);
      onSubmit(quiz_data, false);
      setIsStopTimer(false);
      notify();
    }
  };

  const AutoSaveQuiz = () => {
    if (!isReview) {
      const timer = window.sessionStorage.getItem("timer");
      let quiz_data = {
        is_submit: false,
        time_spent: parseInt(timer),
        answers,
      };
      onSubmit(quiz_data, false);
      setIsStopTimer(false);
    }
  };

  const creatQuizDataThenSaveAndExit = () => {
    if (!isReview) {
      const timer = window.sessionStorage.getItem("timer");
      let quiz_data = {
        is_submit: false,
        time_spent: parseInt(timer),
        answers,
      };
      setIsStopTimer(true);
      onSubmit(quiz_data, true);
      setIsStopTimer(false);
      setIsSystemRedirection(true);
      notify();
    }
  };

  let words_count, written_text;
  const onBlur = (e) => {
    answers = e.target.value;
    AutoSaveQuiz();
  };

  const textarea_change = (e) => {
    written_text = e.target.value;
    answers = written_text;
    words_count = written_text.replace(/[\n]/g, " ").trim().split(" ").length;
    if (!written_text) {
      words_count = 0;
    }
    setWordsCount(words_count);
  };
  const handleCopyPaste = (e) => {
    if(data && !data.allow_copy_paste){
      e.preventDefault();
    }
  };
  const { handleSubmit } = useForm();

  const onFormSubmit = () => {
    if (wordsCounter < 100 || wordsCounter > 1000) {
      toast.error(
        "Answer length must be between 100 and 1000 words, current words are: " +
          wordsCounter,
        {
          position: "top-right",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: 1,
        }
      );
    } else {
      setModal(!modal);
    }
  };

  let class_name = "exercise-bg-grammer";
  if (data.task_type === exerciseType.GRAMMAR_TASK) {
    class_name = "exercise-bg-grammer";
  } else if (data.task_type === exerciseType.WRITING_TASK) {
    class_name = "exercise-bg-writing";
  } else if (data.task_type === exerciseType.VOCABULARY_TASK) {
    class_name = "exercise-bg-vocab";
  } else if (data.task_type === exerciseType.PRONUNCIATION_TASK) {
    class_name = "exercise-bg-pronunciation";
  } else if (data.task_type === exerciseType.READING_TASK) {
    class_name = "exercise-bg-reading";
  } else if (data.task_type === exerciseType.READING_TASK){
    class_name = "exercise-bg-listening";
  }

  if (!isLoaded)
    return <h1 className="text-primary text-center">Loading...</h1>;
  return (
    <div className={`dashboard-wrapper ${wraperbackground}`}>
      <div class={`${container}`}>
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <div className={`row ${padding}`}>
            <div className={`sm-py-1 ${quizbackground}`}>
              <div ref={contentRef}>
                <Row>
                  <div className="Header d-none">
                  <Row className="bg-white pb-3">
                    <Header 
                      data={data}                           
                      click={creatQuizDataThenSaveAndExit}
                      getStudentid={getStudentid} 
                    />
                  </Row>
                  </div>
                </Row>
                <div className={`quiz-detail ${Quizyheight}`}>
                  <div id="scroll" className={`${Questionscroll}`}>
                {window.location.origin.includes(QuizyUrl) || quizy_template === "true" ? (
                  <div
                    className={`bg-white row rounded-header border border-bottom-0`}
                  >
                    <TempHeader 
                      isReview={isReview}
                      data={data}
                      isStopTimer={isStopTimer}
                      setIsStopTimer={setIsStopTimer}
                      timer={timer}
                      edit_template={edit_template} 
                    />
                  </div>
                ):(
                <div
                  className={`px-4 ${p_size} ${class_name} row rounded-header border border-bottom-0`}
                  xs="1"
                  sm="1"
                  md="4"
                >
                  <div className="col-xl-4 col-xxl-4 col-lg-4 col-md-4  col-sm-12 px-1">
                  <Col className="d-flex align-items-center">
                    <div className="sm-display col-12">
                      <div className="col-5 d-flex">
                        <div className="overlap-parent me-2">
                          {data.task_levels &&
                            data.task_levels.map((level, index) => (
                              <Level key={index} level={level.value} edit_template={edit_template} />
                            ))}
                        </div>
                        <div className="align-self-center">
                          <ExerciseType title={data.task_type.split(" ")[0]} edit_template={edit_template} />
                        </div>
                      </div>
                      {data?.user_type === AccountType.STUDENT ? (
                        <div className="col-7 text-end">
                            <span className="p-1 text-nowrap">
                              <b>
                                {data && timer && (
                                  <Timer
                                    edit_template={edit_template}
                                    isStopTimer={
                                      data.user_type !== AccountType.STUDENT || isReview
                                        ? true
                                        : isStopTimer
                                    }
                                    nature_of_test={data.type}
                                    totalTimeInSeconds={data?.assignment_allowed_time}
                                    localSpentTime={timer}
                                    onStop={(props) => {
                                      // alert("Times up");
                                      setIsStopTimer(false);
                                      // creatQuizDataAndSubmit();
                                    }}
                                  />
                                )}
                              </b>
                            </span>
                        </div>
                      ): null}
                    </div>
                    <div className="lg-display">
                      <div className="overlap-parent me-2">
                        {data.task_levels &&
                          data.task_levels.map((level, index) => (
                            <Level key={index} level={level.value} edit_template={edit_template} />
                          ))}
                      </div>
                      <div>
                        <ExerciseType title={data.task_type.split(" ")[0]} edit_template={edit_template} />
                      </div>
                    </div>
                  </Col>
                  </div>
                  <div className="col-xl-8 col-xxl-8 col-lg-8 col-md-8 col-sm-12 d-flex lg-display px-1">
                    {data?.user_type === AccountType.STUDENT ? (
                      <div className="col-12 d-flex">
                        <Col md className="col-6 timer-text align-self-center center">
                          <span className="p-1 text-nowrap">
                            <b>
                              {data && timer && (
                                <Timer
                                  edit_template={edit_template}
                                  isStopTimer={
                                    data.user_type !== AccountType.STUDENT || isReview
                                      ? true
                                      : isStopTimer
                                  }
                                  nature_of_test={data.type}
                                  totalTimeInSeconds={data?.assignment_allowed_time}
                                  localSpentTime={timer}
                                  onStop={(props) => {
                                    // alert("Times up");
                                    setIsStopTimer(false);
                                    // creatQuizDataAndSubmit();
                                  }}
                                />
                              )}
                            </b>
                          </span>
                        </Col>
                        <Col md className="col-6 center justify-content-end">
                          <SuggestedTime time={data?.assignment_allowed_time} Contentedit={Contentedit} data={data} edit_template={edit_template} />
                        </Col>
                      </div>
                    ):null}
                  </div>
                </div>
                )}
                  <Row className="border border-top-0 border-bottom-0 bg-white px-3 py-2">
                    <Col>
                      <div class="d-flex flex-column">
                        <h1 className="d-none">{data.prompt_content}</h1>
                        <QuestionHeading data={data} isBlinking={isBlinking} setIsBlinking={setIsBlinking} focusblink={focusBlink} blurblink={blurBlink} setContentedit={setContentedit} Contentedit={Contentedit} onUpdate={onUpdate} />
                        <QuestionDescription
                          description={
                            <div
                              contentEditable={Contentedit}
                              spellcheck="false"
                              data-gramm="false"
                              onFocus={focusBlink}
                              onBlur={blurBlink}
                              onInput={handleHeaderInput({
                                type: "htmlcontent",
                                quizdata: data,
                              })}
                              dangerouslySetInnerHTML={{
                                __html: data.html_content,
                              }}
                            />
                          }
                          showbtn={true}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row
                    className={
                      size(data.additional_resource) <= 0 ? "" : "p-3 border"
                    }
                  >
                    {size(data.additional_resource) <= 0 ? (
                      ""
                    ) : (
                      <div>
                        <p className="quiz-bottom-border mb-3"></p>
                        <span class="font-size-18 mt-3 mb-3">
                          <strong> Additional question resource </strong>
                          <OpenButton
                            onClick={() =>
                              setOpenAdditionalResourceModal(
                                !isOpenAdditionalResourceModal
                              )
                            }
                          />
                        </span>
                        <p className="quiz-bottom-border mt-3"></p>
                      </div>
                    )}

                    <SimpleModal
                      isOpen={isOpenAdditionalResourceModal}
                      toggle={additionalResourceToggle}
                      bodyContent={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.additional_resource,
                          }}
                        />
                      }
                      footerContent={
                        <button
                          type="submit"
                          class="btn btn-sm mx-3 modal-button"
                          onClick={additionalResourceToggle}
                        >
                          Close
                        </button>
                      }
                    />
                  </Row>
                  <Row className="border border-top-0 border-bottom-0 bg-white px-4 py-2">
                    <TextArea
                      defaultValue={
                        data.completed_at === null ? data.answers : null
                      }
                      onCopy={handleCopyPaste}
                      onPaste={handleCopyPaste}
                      value={isReview ? data.answers : null}
                      onchange={textarea_change}
                      onBlur={onBlur}
                      data-tc="writitng-text"
                    />
                  </Row>
                  <p className=" quiz-bottom-border mx-3"></p>
                  <Row className={`border border-top-0 ${temp_rounded} bg-white px-4 py-2 `}>
                    <span className="text-muted">
                      {" "}
                      Words: {wordsCounter} words{" "}
                    </span>
                  </Row>
                  </div>
                  <Row id="footer" className={`${margin0}`}>
                    {!pathname.includes(TempUrl) && edit_template !== "true" && (

                    <BottomButtonPannel
                      isReview={isReview}
                      data={data}
                      isSubmitting={false}
                      creatQuizDataThenSaveAndExit={creatQuizDataThenSaveAndExit}
                      creatQuizDataAndSave={creatQuizDataAndSave}
                      getStudentid={getStudentid}
                      student_level={null}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      return_to_assignment_list={return_to_assignment_list}
                      book_id={book_id}
                      exercise_id={exercise_id}
                      exercise_page_number={exercise_page_number}
                      show_exercises={show_exercises}
                      search={search}
                      st_c_t_c={st_c_t_c}
                      st_le_c={st_le_c}
                      ex_b_c={ex_b_c}
                      st_th_c={st_th_c}
                      st_fn_c={st_fn_c}
                      st_gr_c={st_gr_c}
                      downloadPDF={downloadPDF}
                      ReportToggle={ReportToggle}
                    />
                    )}
                  </Row>
                </div>
            </div>
            </div>
            <Row id="report_bug" className={`lg-display ${Reportbug}`}>
              <ReportBugButton />
            </Row>
          </div>
        </form>
      </div>

      <WaitModel isOpen={waitModal} toggle={waitToggle} message={message} />

      <ConfirmationModal
        isOpen={modal}
        toggle={toggle}
        onClick={creatQuizDataAndSubmit}
      />
      <SampleReportModal
        isOpen={ReportModal}
        toggle={ReportToggle}
      />
    </div>
  );
};

export default WrittingQuiz;
